import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useRef, useState } from "react";
import CaptchaComponent from "./CaptchaComponent";
import OTPInput from "react-otp-input";
import {contactUsEmail} from "../../utility/emailUtility";


const ContactUs = () => {



    const handleContactUs = () => {
        setIsContactOpen(true);
    }
    const [isContactOpen, setIsContactOpen] = useState(false);

    const fullNameInputRef = useRef(null);
    const selectISDRef = useRef(null);
    const mobileRef = useRef(null);
    const emailRef = useRef(null);


    const [username, setFullName] = useState("");

    const [isdcodes, setISDCode] = useState([]);
    const [selectedISDCode, setSelectedISDCode] = useState('99');

    const [isVisibleOTP, setIsVisibleOTP] = useState(false);
    const [isVisibleMobile, setIsVisibleMobile] = useState(true);
    const [isVerified, setIsVerified] = useState(false)


    const [isdSearchTerm, setISDSearchTerm] = useState('');

    const [isValidMobile, setIsValidMobile] = useState(true);
    const [mobileNumber, setMobileNumber] = useState('');
    const [email, setEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);

    const [requestDetails, setRequestDetails] = useState('');
    const captchaRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState('');
    const [enteredCaptcha, setEnteredCaptcha] = useState('');

    const [otp, setOtp] = useState(""); // Added state for OTP
    const [otp2, setOtp2] = useState(""); // Added state for OTP

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Reset input fields when the modal opens
    useEffect(() => {

        // Clear form fields
        setFullName('');
        setSelectedISDCode('99');
        setMobileNumber('');
        setEmail('');
        setRequestDetails('');
        setEnteredCaptcha('');

        // Set focus on the full name input
        if (fullNameInputRef.current) {
            fullNameInputRef.current.focus();
        }

        // Fetch ISD codes when modal is opened
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ISDCodeList', setISDCode);

    }, []);


    const handleFullNameChange = (event) => {
        setFullName(event.target.value);
    };

    // Handle ISD code change
    const handleISDCodeChange = (event) => {
        setSelectedISDCode(event.target.value);
        setMobileNumber("");
    };

    const handleMobileNumberChange = async (event) => {
        const inputMobileNumber = event.target.value;
        const maxLength = selectedISDCode === '99' ? 10 : 11;
        if (/^\d*$/.test(inputMobileNumber) && inputMobileNumber.length <= maxLength) {
            setMobileNumber(inputMobileNumber);
            setIsValidMobile(true);

        } else {
            setIsValidMobile(false);
        }
    };

    const handleEmailChange = async (event) => {
        const inputEmail = event.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmail(inputEmail);
        setIsValidEmail(emailRegex.test(inputEmail) || inputEmail === "");
    };


    const handleKeyPress = (event) => {
        const value = isdSearchTerm + event.key;
        setISDSearchTerm(value);

        const exactMatch = isdcodes.find(code => code.isdCode === value);
        const partialMatch = isdcodes.find(code => code.isdCode.startsWith(value) || code.isdCodeName.toLowerCase().includes(value.toLowerCase()));

        const match = exactMatch || partialMatch;

        if (match) {
            handleISDCodeChange({ target: { value: match.isdCode } });
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => setISDSearchTerm(''), 500);
        return () => clearTimeout(timeoutId);
    }, [isdSearchTerm]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (username.trim() === '') {
            alert('Please enter your full name.');
            fullNameInputRef.current.focus();
            return;
        }
        if (mobileNumber.trim() === '') {
            alert('Please enter mobile number');
            mobileRef.current.focus();
            return;
        }
        const minLength = selectedISDCode === '99' ? 10 : 8; // Minimum length depends on ISD code

        if (mobileNumber.length !== minLength) {
            alert('Please enter a valid mobile number with the correct number of digits.');
            mobileRef.current.focus();
            return;
        }
        if (!isValidMobile) {
            alert('Please enter a valid mobile number.');
            mobileRef.current.focus();
            return;
        }
        // Validate CAPTCHA
        // Focus on the captcha input
        if (enteredCaptcha.trim() === '') {
            alert("Please enter the captcha.");
            if (captchaRef.current) { // Ensure captchaRef is not null before focusing
                captchaRef.current.focus();
            }
            return;
        }
        if (enteredCaptcha !== captchaValue) {
            alert("Invalid captcha");
            if (captchaRef.current) {
                captchaRef.current.value = ''; // Clear the input field if captcha is invalid
                captchaRef.current.focus();
            }
            return;
        }

        // Form data to send
        const requestData = {
            enquiryType: 2,
            visitorName: username,
            visitorISD: selectedISDCode,
            visitorMobile: mobileNumber,
            visitorEmail: email,
            visitorMessage: requestDetails
        };

        // Example API call to save data
        try {
            debugger;
            const response = await fetch('https://igapi.heuristticminds.com/api/VisitorList/Add-InsertTDVisitorsEnquiry', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });

            if (response.ok) {
                // Find the corresponding phonecode for the selected ISD code
                const selectedISD = isdcodes.find(code => code.isdCode === selectedISDCode);

                if (selectedISD) {
                    const phonecode = selectedISD.phonecode; // Get phonecode (e.g., 91 for India)
                    //alert(`Phonecode: ${phonecode}`);

                    // Proceed to send email
                    const success = await contactUsEmail(username, phonecode, mobileNumber, email, requestDetails);
                    if (success) {
                        alert('Visitor`s enquiry sent successfully');
                    } else {
                        alert('Visitor`s enquiry saved, but email failed.');
                    }
                }
                //onClose(); // Close the modal after successful submission
            } else {
                alert('Failed to submit the request. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting enquiry:', error);
            alert('An error occurred. Please try again later.');
        }
    };

   


    const handleCaptchaChange = (generatedCaptcha, userInput) => {
        setCaptchaValue(generatedCaptcha); // Set the generated CAPTCHA
        setEnteredCaptcha(userInput); // Set the entered CAPTCHA
    };

    

    const generateOtp = () => {
        // Generate a 4-digit OTP
        const min = 1000;
        const max = 9999;
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    const handleOTP = async () => {
        const generatedOtp = generateOtp();
        setOtp2(generatedOtp.toString()); // Update otp2 using the setOtp2 function
        setIsVisibleOTP(true);
        setIsVisibleMobile(false)
        alert(generatedOtp)

    };

    const verifyOTP = async () => {
        if (otp === otp2) {
            alert("Mobile verified")
            setIsVerified(true);
            setIsVisibleOTP(false);
            setIsVisibleMobile(true)

        }
        else {
            alert("Wrong OTP, pls Enter valid OTP!")
            setIsVisibleMobile(false)
            return;
        }
    };


    return (
        <>
            <span className="support_icon" onClick={handleContactUs}><img src="../../../images/icon-send-email.svg" width="26" /></span>

            <div className={`off_canvas ${isContactOpen ? 'open' : ''}`}>
                <div className="off_wrap">
                    <div className="offcanvas_header shadow-sm">
                        <div className="modal-header">
                            <h5>Contact Us</h5>
                        </div>
                        <button onClick={() => { setIsContactOpen(false); }} className="close_btn"><i className="bi bi-x-lg"></i></button>
                    </div>
                    <div className="offcanvas_body">
                        <div className="row">
                            <h4 className="mb-4 mt-3">We'd love to hear from you</h4>
                            <div className="border p-4">
                                <div className='box_request'>

                                    <div className={isVisibleMobile ? "show" : "hide"}>
                                        <div className={`d-flex ${isVerified ? 'verified' : 'not-verified'}`}>
                                            <div className="row_input me-2" style={{ width: 150 }}>
                                                <span className="lbl1">ISD Code</span>
                                                <select
                                                    id="selectedISDCode"
                                                    //ref={selectISDRef}
                                                    value={selectedISDCode}
                                                    name="selectedISDCode"
                                                    className="ddl1"
                                                    onChange={handleISDCodeChange}
                                                    tabIndex={2}
                                                    onKeyDown={handleKeyPress}
                                                >
                                                    <option value="0">--ISD--</option>
                                                    {isdcodes.map((code) => (
                                                        <option key={code.isdCode} value={code.isdCode}>
                                                            {code.isdCodeName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="row_input">
                                                <span className="lbl1">Mobile Number</span>
                                                <input
                                                    type="text"
                                                    value={mobileNumber}
                                                    onInput={handleMobileNumberChange}
                                                    id="mobileNumber"
                                                    tabIndex={3}
                                                    ref={mobileRef}
                                                    placeholder="Enter mobile number"
                                                    //className="txt1"
                                                    className={`txt1 ${isValidMobile ? "" : "is-invalid"}`}
                                                    autoComplete="off"
                                                />

                                            </div>
                                            {!isValidMobile && (
                                                <div className="invalid-feedback">Mobile number exceeds maximum length.</div>
                                            )}

                                            <div className="row_input ms-3" style={{ width: 100 }}>
                                                <span className='btn' onClick={handleOTP}>Verify</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={isVisibleOTP ? "show" : "hide"}>
                                        <div className='text-center'>
                                            <h6>Verify with OTP (Check your phone)</h6>
                                            <div className=''>
                                                <OTPInput
                                                    value={otp}
                                                    onChange={setOtp}
                                                    containerStyle="otp_style"
                                                    numInputs={4}
                                                    renderSeparator={<span>-</span>}
                                                    renderInput={(props) => <input {...props} />}
                                                />
                                                <button type="submit" className="btn btn-dark w-50 font-weight-bold mt-2 p-2 rounded-1" onClick={verifyOTP}>Verify</button>
                                            </div>
                                        </div>
                                    </div>

                                    <form onSubmit={handleSubmit} className={isVerified ? "show" : "hide"}>
                                        <div className="row_input">
                                            <span className="lbl1">Full Name</span>
                                            <input
                                                type="text"
                                                value={username}
                                                id="fullName"
                                                maxLength={35}
                                                onChange={handleFullNameChange}
                                                ref={fullNameInputRef}
                                                tabIndex={1}
                                                placeholder="Enter your full name"
                                                className="txt1"
                                                autoComplete="off"
                                            />
                                        </div>

                                        <div className="row_input">
                                            <span className="lbl1">Email Address</span>
                                            <input
                                                type="text"
                                                value={email}
                                                onInput={handleEmailChange}
                                                id="email"
                                                tabIndex={4}
                                                maxLength={45}
                                                ref={emailRef}
                                                placeholder="Enter your email address"
                                                //className="txt1"
                                                className={`txt1 ${isValidEmail ? "" : "is-invalid"}`}
                                                autoComplete="off"
                                            />
                                            {!isValidEmail && (
                                                <div className="invalid-feedback">Please enter a valid email address.</div>
                                            )}
                                        </div>

                                        <div className="row_input">
                                            <span className="lbl1">Message</span>
                                            <textarea
                                                value={requestDetails}
                                                onChange={(e) => setRequestDetails(e.target.value)}
                                                placeholder="Enter your request details..."
                                                rows="4"
                                                style={modalStyles.textarea}
                                                className='txt1'
                                                tabIndex={5}
                                            />
                                        </div>
                                        <div className="row_input" style={{ marginTop: '2px' }}>
                                            <CaptchaComponent
                                                value={enteredCaptcha}
                                                ref={captchaRef}
                                                onCaptchaChange={handleCaptchaChange}
                                                tabIndex={6}
                                            />
                                        </div>
                                        <div style={modalStyles.buttonContainer}>
                                            <button type="submit" className='btn_viewall' tabIndex={7}>Submit Request</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};


const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 111111,
    },
    modal: {
        background: 'white',
        padding: '20px 50px',
        borderRadius: '5px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        width: '500px',
        position: 'relative',
    },
    textarea: {
        width: '100%',
        minHeight: '80px'
    }
};
export default ContactUs;